import { render, staticRenderFns } from "./EditConsultantContractMilestoneModal.vue?vue&type=template&id=127979d0&"
import script from "./EditConsultantContractMilestoneModal.vue?vue&type=script&lang=ts&"
export * from "./EditConsultantContractMilestoneModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports